import { useSelector } from 'react-redux'
import { selectors, isPakOnlyContext } from 'auth/stores/userContext'
import { extractUserContextOverride } from 'utils/productHelpers'
import { withSafeContext } from 'utils/contextHelpers'
import { isFlagOn } from 'utils/featureFlags'

export function useUserContext() {
  const msSiteSelection = isFlagOn(['feature_LEARN-20108-ms-site-selection'])
  const k5SiteSelection = isFlagOn(['feature_LEARN-20164-k5-site-selection'])

  // Create a safer version of the selectProgramContext selector that
  // handles the case when switching between program types
  const userContext = useSelector(selectors.selectUserContextManager)
  const isPakOnly = isPakOnlyContext(userContext)
  let programConTextSelector = selectors.selectProgramContext

  if (!isPakOnly && (msSiteSelection || k5SiteSelection)) {
    programConTextSelector = selectors.selectProgramContextWithSiteSelection
  }

  const safeSelectProgramContext = withSafeContext(programConTextSelector)

  const userContextOverride = extractUserContextOverride()
  if (userContextOverride) {
    try {
      return JSON.parse(atob(userContextOverride))
    } catch (e) {
      console.warn(
        'Failed to parse base64-encoded userContextOverride',
        userContextOverride,
        'error:',
        e,
      )
    }
  }

  // Always use the safe wrapper for all program types to ensure consistent behavior
  // This will help prevent issues when switching between program types
  return useSelector(safeSelectProgramContext)
}

export function useUserContextWithLoading() {
  const userContext = useUserContext()
  const isUserContextLoading = useSelector(
    state => state.userContextManager?.isFetching,
  )
  const hasUserContext =
    !isUserContextLoading &&
    userContext &&
    Object.keys(userContext).length > 0 &&
    userContext?.sites?.length &&
    userContext?.sites?.[0]

  return {
    userContext,
    isUserContextLoading: !hasUserContext,
  }
}
